import { useEffect, useRef } from 'react'
import { togglePlaybackPlaying } from 'actions/playback'
import { PLAYER_TYPE, PLAYBACK_STATE } from 'enums'
import { useAction } from 'hooks'
import { useSelector } from 'react-redux'
import { PlayerType } from 'types/common'

type UsePreviewSlider = {
  isMedia:boolean,
  preview: PlayerType,
  disabledCtrls: boolean,
}

export const usePreviewSlider = ({ isMedia, preview, disabledCtrls }: UsePreviewSlider) => {
  const sliderContainerRef = useRef<HTMLDivElement | null>(null)
  const memoPlayback = useRef(null)
  const togglePlayback = useAction(togglePlaybackPlaying)
  const playback = useSelector((state: RootState) => state.playback)
  const isMouseDown = useRef(false)

  useEffect(() => {
    const slider = sliderContainerRef.current
    const stop = () => {
      isMouseDown.current = true
      memoPlayback.current = isMedia
        ? playback.clipPlaybackState
        : playback.timelinePlaybackState
      togglePlayback({
        playbackState: PLAYBACK_STATE.PAUSE,
        playerType: isMedia ? PLAYER_TYPE.MEDIA : PLAYER_TYPE.TIMELINE,
      })
    }
    const start = () => {
      if (isMouseDown.current) {
        togglePlayback({
          playbackState: memoPlayback.current,
          playerType: isMedia ? PLAYER_TYPE.MEDIA : PLAYER_TYPE.TIMELINE,
        })
        memoPlayback.current = null
        isMouseDown.current = false
      }
    }
    if (slider && !disabledCtrls) {
      slider.addEventListener('mousedown', stop)
      slider.addEventListener('mouseup', start)
    }
    return () => {
      if (slider) {
        slider.removeEventListener('mousedown', stop)
        slider.removeEventListener('mouseup', start)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ sliderContainerRef, preview, playback, disabledCtrls ])

  return {
    sliderContainerRef,
  }
}
